<template>
  <b-container fluid id="template" class="page">
    <h1>{{this.page.title}}</h1>
    <p class="text-break" v-html="this.page.content"></p>
  </b-container>
</template>

<script>
export default {
  name: "Flex",
  props: ["page"],
  data: function() {
    return {};
  }
};
</script>

<style lang="scss">
#template {
  h1 {
    margin-bottom: 1.2em;
  }
}
</style>